import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'
import {athubAxios} from "@/util";
import {checkResourceNameAvailable} from "@/api/organization/permission";

const role = new RestResource({server: ORGANIZATION_SERVER, resource: 'role'});

role.page = async function page(params) {
    let result = await athubAxios.post(`${ORGANIZATION_SERVER}/role/page`, params);
    if (result.status == 200) {

        // let ids = result.data.data.records.map(e => {
        //     return e.id;
        // });
        // if (ids.length > 0) {
        //
        //     //查看该角色是否是继承而来
        //     params = {roleIds: ids};
        //     let roleHierarchys = await athubAxios.post(`${ORGANIZATION_SERVER}/roleHierarchy/list`, params);
        //     if (roleHierarchys.status == 200) {
        //         //在原来的role里增加上层role的id
        //         result.data.data.records.forEach(e => {
        //             roleHierarchys.data.data.forEach(f => {
        //                 if (e.id == f.roleId) {
        //                     e.extendRoleId = f.extendRoleId + '';
        //                     e.roleHierarchyId = f.id
        //                     return;
        //                 }
        //             })
        //         });
        //     }
        // }
        return result;
    }
};

role.copy = function copy(id) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/role/copy/${id}`).then(res => {
            if (res.status == 200) {
                resolve(res);
            }
        }).catch(error => {
            reject(error);
        });
    });
};

role.menuIds = function selectMenuIdsByRoleId(version, roleId) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/auth/menuId/${version}/${roleId}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
};

role.checkName = function checkNameAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/role/check/name`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
};

role.checkCode = function checkCodeAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/role/check/code`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
};

role.extendTree = function selectRoleExtendTreeByRoleId(id) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/role/extend/tree/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
};

role.dependency = function selectRoleDependencyByRoleId(id) {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/role/dependency/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
};

role.optionsGroup = function selectRoleOptionsGroup() {
    return new Promise((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/role/options/group`)
            .then(result => {
                result.status === 200 ? resolve(result) : reject(result)
            }, (error) => {
                reject(error);
            })
    })
}

role.invalidate = function invalidate(roleId) {
    return new Promise((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/role/invalidate/${roleId}`)
            .then(result => {
                result.status === 200 ? resolve(result) : reject(result)
            }, (error) => {
                reject(error);
            })
    })
}

role.revalidate = function revalidate(roleId) {
    return new Promise((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/role/revalidate/${roleId}`)
            .then(result => {
                result.status === 200 ? resolve(result) : reject(result)
            }, (error) => {
                reject(error);
            })
    })
}

export default role;

export function selectList() {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/role/list`, {})
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}
